
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleeth as ObiLightningSleethElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleeth.js';
 
 
 

 
 export const ObiLightningSleeth = createComponent({
   react: React,
   tagName: 'obi-lightning-sleeth',
   elementClass: ObiLightningSleethElement,
   events: {
     
   }
  });
 
 